import {Spinner} from "reactstrap";

export const Loading = () => (
  <div style={{textAlign: "center"}}>
    <Spinner size="sm" color="dark" />
  </div>
);
